import React, { useState, useEffect, forwardRef } from 'react';
import {
    StyleSheet,
    Text,
    View,
    useWindowDimensions,
    TouchableOpacity
} from 'react-native';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Area
} from 'recharts';
import { MaterialIcons } from '@expo/vector-icons';
import DatePicker from "react-datepicker";
import Data from './Data';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import {
    setStorage,
    getStorage,
    removeStorage
} from '../storage';
import { CSVLink } from "react-csv";
const CheckBox = ({ checked, color }: any) => {

    return (
        <View>
            {checked ?
                <MaterialIcons name="radio-button-on" size={20} color={color} />
                :
                <MaterialIcons name="radio-button-unchecked" size={20} color={color} />
            }
        </View>
    )
};



const CheckList = ({ item, num, sensorItems, setSensorItems, locationItems, setLocationItems }: any) => {
    const [checked, setChecked] = useState(true);

    const onCheck = (item: any) => {
        setChecked(!checked);
        console.log('checked ?? ', checked);
        if (!checked) {
            if (num == 1) {
                setSensorItems([...sensorItems, item]);
            } else {
                setLocationItems([...locationItems, item]);
            }
        } else {
            if (num == 1) {
                setSensorItems(sensorItems.filter((el: any) => el?.dataKey !== item?.dataKey));
            } else {
                setLocationItems(locationItems.filter((el: any) => el?.dataKey !== item?.dataKey));
            }
        }
    };

    return (
        <TouchableOpacity onPress={() => { onCheck(item) }}
            style={{ flexDirection: 'row', alignItems: 'center', marginHorizontal: 10 }} >
            <CheckBox checked={checked} color={item?.color} />
            <Text style={{ marginLeft: 5, color: item?.color }}>{item?.name}</Text>
        </TouchableOpacity>
    )
};

// ─── 접근 제한 ──────────────────────────────────────────────
// 원시 데이터 화면(개발·연구용)이라 최고관리자(ADMIN='0')만 연다.
// 버튼을 가려도 주소로 들어올 수 있어 화면에서도 막는다.
// ★ 본문 안에서 조기 return 하면 훅 순서가 깨진다("Rendered fewer hooks than expected").
//   그래서 바깥에서 감싸고, 통과했을 때만 본문 컴포넌트를 띄운다.
export default function SensorHistoryGate(props: any) {
    const [adm, setAdm] = useState<string | null>(null);
    useEffect(() => { getStorage('AutoLogin').then((v: any) => setAdm(String(v?.admin ?? '1'))); }, []);
    if (adm === null) return null;
    if (adm !== '0') {
        return (
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24 }}>
                <Text style={{ fontSize: 16, fontWeight: '700', color: '#475569', marginBottom: 6 }}>접근 권한이 없습니다</Text>
                <Text style={{ fontSize: 13, color: '#94A3B8', textAlign: 'center' }}>이 화면은 최고관리자만 볼 수 있습니다.</Text>
            </View>
        );
    }
    return <SensorHistory {...props} />;
}

function SensorHistory({ route, navigation }: any) {
    const [csvReport, setCsvReport] = useState<any>({
        data: [],
        headers: [],
        filename: 'csvdata.csv'
    }); 
    const sensorID = route?.params?.sensorID;
    const { height, width } = useWindowDimensions();
    const chartWidth = width * 0.95;
    const chartHeight = height * 0.4;
    const [data, setData] = useState<any>([]);
    const [startDate, setStartDate] = useState<any>(new Date());
    const [endDate, setEndDate] = useState<any>(new Date());
    const StartDate = moment(startDate).format('YYYY-MM-DD HH:mm');
    const EndDate = moment(endDate).format('YYYY-MM-DD HH:mm');
    const sensorItem = [
        { dataKey: 'VCC', name: '전압 값', color: '#8884d8' },
        { dataKey: 'CAP1', name: '센서 값1', color: 'green' },
        { dataKey: 'CAP2', name: '센서 값2', color: 'orange' },
    ];
    const locationItem = [
        { dataKey: 'ACC_X', name: 'x 값', color: '#8884d8' },
        { dataKey: 'ACC_Y', name: 'y 값', color: 'green' },
        { dataKey: 'ACC_Z', name: 'z 값', color: 'orange' }
    ];

    const [sensorItems, setSensorItems] = useState<any>(sensorItem);
    console.log('sensorItems ??', sensorItems);
    const [locationItems, setLocationItems] = useState<any>(locationItem);
    console.log('locationItems ??', locationItems);

    const [sensorBase, setSensorBase] = useState<any>({
        data: [],
        headers: [],
        filename: 'csvdata.csv'
    });
    const [analyze, setAnalyze] = useState<any>({
        data: [],
        headers: [],
        filename: 'csvdata.csv'
    });    

    useEffect(() => {
        const load = async () => {
            setCsvLoading(true);
            setCsvReady(false);

            const Start = await getStorage('StartDate');
            const End = await getStorage('EndDate');

            const startDate = Start ? moment(new Date(Start)).format('YYYY-MM-DD HH:mm') : '';
            const endDate = End ? moment(new Date(End)).format('YYYY-MM-DD HH:mm') : '';

            if (Start) setStartDate(new Date(Start));
            if (End) setEndDate(new Date(End));

            const analyzeHeaders = [
                { label: "SENSOR_ID", key: "SENSOR_ID" },
                { label: "start", key: "start" },
                { label: "end", key: "end" },
                { label: "status", key: "status" },
                { label: "정상", key: "Normal" },
                { label: "에러", key: "Error" },
                { label: "알수없음", key: "Unknown" },
                { label: "정확도", key: "percentage" }
            ];
            var analyzeFilename = `${sensorID}_Analyze_` + moment(StartDate).format('YYYYMMDD');

            // 1️⃣ 센서 값 조회 (공통)
            Data.fetchData(
                'sensor/GetSensorValues',
                {
                    SENSOR_ID: sensorID,
                    STARTDATE: startDate,
                    ENDDATE: endDate
                },
                (result: any, count: any) => {
                    if (count > 0) {
                        const list = result.sort((a: any, b: any) => a.ID - b.ID);
                        setData(list);
                    }
                },
                true
            );

            // 2️⃣ CSV / 분석 데이터 (날짜 있을 때만)
            if (Start || End) {
                Data.fetchData(
                    'sensor/dateTimeFilteredHistory2',
                    {
                        SENSOR_ID: sensorID,
                        STARTDATE: startDate,
                        ENDDATE: endDate
                    },
                    (result: any, count: any) => {
                        if (count > 0) {
                            const data = result.map((item: any) => ({
                                ...item,
                                start: moment(item.start).format('YYYY:MM:DD HH:mm'),
                                end: moment(item.end).format('YYYY:MM:DD HH:mm'),
                            }));

                            setAnalyze({
                                data,
                                headers: analyzeHeaders,
                                filename: `${analyzeFilename}.csv`
                            });
                        }
                        setCsvLoading(false);
                        setCsvReady(true);
                    },
                    true
                );
            } else {
                // 날짜 없을 때도 로딩 종료 보장
                setCsvLoading(false);
                setCsvReady(true);
            }
        };

        load();
    }, []);


    const timeFommet = (time: any) => {
        if (time) return moment(time).format('HH:mm')
        else return time
    };

    const CustomTooltip = ({ active, payload, label }: any) => {
        if (active && payload) {
            return (
                <View style={styles.tooltip}>
                    <Text style={{ color: '#000', marginBottom: 10 }}>{moment(label).format('YYYY-MM-DD HH:mm')}</Text>
                    {payload?.map((item: any) => {
                        return (<Text key={item?.dataKey} style={{ color: item?.color, marginBottom: 8 }}>{item?.dataKey} : {item?.value}</Text>)
                    })}
                </View >
            )
        }
        return null;
    };

    const CustomStartDatePicker = ({ value, onClick }: any, ref: any) => {
        return (
            <TouchableOpacity onPress={() => { onClick() }} style={styles.datePickerBox}>
                <Text style={{ fontSize: 16, color: '#000' }}>{value}</Text>
            </TouchableOpacity>
        )
    };

    const CustomEndDatePicker = ({ value, onClick }: any, ref: any) => {
        return (
            <TouchableOpacity onPress={() => { onClick() }} style={styles.datePickerBox}>
                <Text style={{ fontSize: 16, color: '#000' }}>{value}</Text>
            </TouchableOpacity>
        )
    };

    const OnStartDatePicker = () => {
        return (
            <DatePicker
                selected={startDate}
                onChange={(date: any) => { setStartDate(date) }}
                timeInputLabel="Time:"
                dateFormat="yyyy-MM-dd HH:mm"
                timeFormat="HH:mm"
                showTimeSelect
                timeIntervals={5}
                customInput={<CustomStartDatePicker />}
            />
        )
    };

    const OnEndDatePicker = () => {
        return (
            <DatePicker
                selected={endDate}
                onChange={(date) => { setEndDate(date) }}
                timeInputLabel="Time:"
                dateFormat="yyyy-MM-dd HH:mm"
                timeFormat="HH:mm"
                showTimeSelect
                timeIntervals={5}
                customInput={<CustomEndDatePicker />}
            />
        )
    };

    const [csvLoading, setCsvLoading] = useState(false);
    const [csvReady, setCsvReady] = useState(false);


    const onSearch = () => {
        setStorage('StartDate', startDate);
        setStorage('EndDate', endDate);
        setCsvLoading(true);
        setCsvReady(false);
        Data.fetchData('sensor/GetSensorValues', {
            SENSOR_ID: sensorID,
            STARTDATE: StartDate,
            ENDDATE: EndDate
        }, (result: any, count: any) => {
            console.log('GetSensorValues ??', result);
            if (count > 0) {
                var list = result.sort(function (a: any, b: any) { return a.ID - b.ID });
                setData(list);
            }
        }, true);
        const sensorBaseHeaders = [
            { label: "SENSOR_ID", key: "SENSOR_ID" },
            { label: "base", key: "base" },
            { label: "end", key: "end" },
            { label: "status", key: "status" },
            { label: "diffcap1", key: "diffcap1" },
            { label: "diffcap2", key: "diffcap2" }
        ];
        var sensorBaseFilename = `${sensorID}_Base_` + moment(StartDate).format('YYYYMMDD');
        const analyzeHeaders = [
            { label: "SENSOR_ID", key: "SENSOR_ID" },
            { label: "start", key: "start" },
            { label: "end", key: "end" },
            { label: "status", key: "status" },
            { label: "정상", key: "Normal" },
            { label: "에러", key: "Error" },
            { label: "알수없음", key: "Unknown" },
            { label: "정확도", key: "percentage" }
        ];
        var analyzeFilename = `${sensorID}_Analyze_` + moment(StartDate).format('YYYYMMDD');

        Data.fetchData('sensor/GetSensorBaseValue', {
            SENSOR_ID: sensorID,
            STARTDATE: StartDate,
            ENDDATE: EndDate
        }, (result: any, count: any) => {
            console.log('GetSensorBaseValue ??', result);
        
            // count가 0보다 큰 경우에만 처리
            if (count > 0) {
                var data = result.map((item: any) => {
                    return {
                        ...item,
                        base: moment(item.base).format('YYYY:MM:DD HH:mm'),
                        end: moment(item.end).format('YYYY:MM:DD HH:mm')
                    };
                });
                // 분석 결과를 상태로 설정
                setSensorBase({
                    data: data,  // 포맷팅된 데이터를 사용
                    headers: sensorBaseHeaders,
                    filename: `${sensorBaseFilename}.csv`
                });
            }
        }, true);
        Data.fetchData(
            'sensor/dateTimeFilteredHistory2',
            {
                SENSOR_ID: sensorID,
                STARTDATE: StartDate,
                ENDDATE: EndDate
            },
            (result: any, count: any) => {
                if (count > 0) {
                    const data = result.map((item: any) => ({
                        ...item,
                        start: moment(item.start).format('YYYY:MM:DD HH:mm'),
                        end: moment(item.end).format('YYYY:MM:DD HH:mm'),
                    }));

                    setAnalyze({
                        data,
                        headers: analyzeHeaders,
                        filename: `${analyzeFilename}.csv`
                    });
                }
                setCsvLoading(false);
                setCsvReady(true);
            },
            true
        );   
    };

    const onRecentView = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setCsvLoading(true);
        setCsvReady(false);
        removeStorage('StartDate');
        removeStorage('EndDate');
        Data.fetchData('sensor/GetSensorValues', {
            SENSOR_ID: sensorID,
            STARTDATE: '',
            ENDDATE: ''
        }, (result: any, count: any) => {
            console.log('GetSensorValues ??', result);
            if (count > 0) {
                var list = result.sort(function (a: any, b: any) { return a.ID - b.ID });
                setData(list);
            }
        }, true);
        const analyzeHeaders = [
            { label: "SENSOR_ID", key: "SENSOR_ID" },
            { label: "start", key: "start" },
            { label: "end", key: "end" },
            { label: "status", key: "status" },
            { label: "정상", key: "Normal" },
            { label: "에러", key: "Error" },
            { label: "알수없음", key: "Unknown" },
            { label: "정확도", key: "percentage" }
        ];
        var analyzeFilename = `${sensorID}_Analyze_` + moment(StartDate).format('YYYYMMDD');        
        Data.fetchData(
            'sensor/dateTimeFilteredHistory2',
            {
                SENSOR_ID: sensorID,
                STARTDATE: StartDate,
                ENDDATE: EndDate
            },
            (result: any, count: any) => {
                if (count > 0) {
                    const data = result.map((item: any) => ({
                        ...item,
                        start: moment(item.start).format('YYYY:MM:DD HH:mm'),
                        end: moment(item.end).format('YYYY:MM:DD HH:mm'),
                    }));

                    setAnalyze({
                        data,
                        headers: analyzeHeaders,
                        filename: `${analyzeFilename}.csv`
                    });
                }
                setCsvLoading(false);
                setCsvReady(true);
            },
            true
        );         
    };

const isLargeData = data.length >= 35;

const ticks = isLargeData
    ? [data[0]?.TIME, data[data.length - 1]?.TIME]
    : undefined;

    return (
        <View style={styles.container}>
            <View style={[styles.selectBox, { zIndex: 50, flexDirection: 'column' }]}>
                <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                    <OnStartDatePicker />
                    <Text style={{ color: '#000', fontSize: 24, marginBottom: 20, marginHorizontal: 20 }}> ~ </Text>
                    <OnEndDatePicker />
                    <TouchableOpacity style={styles.searchBox} onPress={() => { onSearch() }}>
                        <Text style={{ fontSize: 22, color: '#fff' }}>검색</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.searchBox, { backgroundColor: 'green' }]} onPress={() => { onRecentView() }}>
                        <Text style={{ fontSize: 22, color: '#fff' }}>최근보기</Text>
                    </TouchableOpacity>
                    <View style={{ marginLeft: 10 }}>
                        <CSVLink {...sensorBase}>SensorBaseValue</CSVLink>
                    </View>
                    <View style={{ marginLeft: 10 }}>
                        {csvReady ? (
                            <CSVLink {...analyze}>AnalyzSensorHis</CSVLink>
                        ) : (
                            <Text style={{ color: 'gray' }}>
                                AnalyzSensorHis 생성 중...
                            </Text>
                        )}
                    </View>                    
                </View>

            </View>
            {/* <View style={styles.selectBox}>
                {sensorItem?.map((item: any) => {
                    return (<CheckList key={item?.dataKey} item={item} num={1} sensorItems={sensorItems} setSensorItems={setSensorItems} />)
                })}
            </View> */}
            <View style={{ justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <LineChart width={chartWidth} height={chartHeight} data={data}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis dataKey="TIME" tickFormatter={timeFommet} interval={0} ticks={ticks}/>
                    <YAxis domain={['dataMin', 'dataMax']}/>
                    {/* {sensorItems?.map((item: any) => {
                        return (
                            <Line key={item?.dataKey} type="monotone" dataKey={item?.dataKey} stroke={item?.color} dot={false} />
                        )
                    })} */}
                    <Line type="monotone" dataKey={'CAP1'} stroke={'green'} dot={false} />
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
                <LineChart width={chartWidth} height={chartHeight} data={data}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis dataKey="TIME" tickFormatter={timeFommet} interval={0} ticks={ticks}/>
                    <YAxis domain={['dataMin', 'dataMax']} />
                    <Line type="monotone" dataKey={'CAP2'} stroke={'orange'} dot={false} />
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
            </View>
            <View style={styles.selectBox}>
                {locationItem?.map((item: any) => {
                    return (<CheckList key={item?.dataKey} item={item} num={2} locationItems={locationItems} setLocationItems={setLocationItems} />)
                })}
            </View>
            <View style={{ justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <LineChart width={chartWidth} height={chartHeight} data={data}
                    margin={{ top: 20, bottom: 20, right: 40 }} >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis dataKey="TIME" tickFormatter={timeFommet} interval={0} ticks={ticks}/>
                    <YAxis domain={['dataMin', 'dataMax']} />
                    {locationItems?.map((item: any) => {
                        return (
                            <Line key={item?.dataKey} type="monotone" dataKey={item?.dataKey} stroke={item?.color} dot={false} />
                        )
                    })}
                    <Legend />
                    <Tooltip content={CustomTooltip} />
                </LineChart>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        paddingHorizontal: 30
    },
    selectBox: {
        borderWidth: 1,
        borderRadius: 10,
        width: '100%',
        paddingVertical: 15,
        marginTop: 10,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: '#e8eade',
        shadowColor: '#d9dbec',
        shadowOffset: {
            width: 0,
            height: 5,
        },
        shadowOpacity: 0.55,
        shadowRadius: 15,
        elevation: 5,
    },
    tooltip: {
        borderWidth: 1,
        borderColor: '#e8eade',
        padding: 15,
        backgroundColor: '#fff'
    },
    datePickerBox: {
        borderWidth: 1,
        borderColor: 'grey',
        justifyContent: 'center',
        alignItems: 'center',
        width: 200,
        paddingHorizontal: 15,
        paddingVertical: 5,
        borderRadius: 10
    },
    searchBox: {
        backgroundColor: 'skyblue',
        borderRadius: 15,
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 5,
        paddingHorizontal: 15,
        marginLeft: 20
    },

});